<template>
  <v-layout justify-center>
    <v-flex md8 xs12>
      <div>
        <!-- v-bind:editable="editable" -->
        <DocumentRename
          v-model="enable_rename_form"
          v-bind:documentProp="document_to_rename"
          v-on:document-rename="handleDocumentRename"
        ></DocumentRename>
        <v-layout row>
          <v-flex xs12>
            <!-- Document upload -->
            <v-flex xs12 mt-3 mb-5>
              <v-btn
                @click="triggerDocumentInputClick"
                color="success"
                small
                class="ml-0"
                v-if="
                  event.status !== 'completed' && event.status !== 'archive'
                "
              >
                <v-icon small>fa-upload fa-fw</v-icon>&nbsp;{{
                  $t('labels.document_upload')
                }}
              </v-btn>
              <input
                @change="handleDocumentInputChange"
                accept="*"
                multiple
                ref="documentInput"
                style="display: none"
                type="file"
              />
            </v-flex>
            <v-list two-line subheader style="background-color: inherit">
              <v-list-tile
                v-for="(document, key) in event.documents"
                :key="key"
                avatar
              >
                <v-list-tile-avatar>
                  <v-icon :class="[document.getIconClass()]">{{
                    document.getIcon()
                  }}</v-icon>
                </v-list-tile-avatar>

                <v-list-tile-content>
                  <v-list-tile-title
                    ><a target="_blank" :href="document.link">{{
                      document.original_name
                    }}</a></v-list-tile-title
                  >
                  <v-list-tile-sub-title v-if="document.isPrivate()"
                    >{{ $t('components.eventTabDocuments.status') }}:
                    {{ $t('components.eventTabDocuments.private') }}
                    <v-icon color="grey lighten-1" small
                      >fa-user-secret</v-icon
                    ></v-list-tile-sub-title
                  >
                  <v-list-tile-sub-title v-else
                    >{{ $t('components.eventTabDocuments.status') }}:
                    {{ $t('components.eventTabDocuments.public') }}
                    <v-icon color="grey lighten-1" small
                      >fa-globe</v-icon
                    ></v-list-tile-sub-title
                  >
                </v-list-tile-content>

                <v-list-tile-action v-if="document.isPrivate()">
                  <v-btn icon ripple @click="setPublic(document)">
                    <v-icon color="grey lighten-1">fa-globe</v-icon>
                  </v-btn>
                </v-list-tile-action>
                <v-list-tile-action v-else>
                  <v-btn icon ripple @click="setPrivate(document)">
                    <v-icon color="grey lighten-1">fa-user-secret</v-icon>
                  </v-btn>
                </v-list-tile-action>
                <v-list-tile-action>
                  <v-btn
                    icon
                    ripple
                    @click="openDocumentRenameDialog(document)"
                  >
                    <v-icon color="grey lighten-1">fa-edit</v-icon>
                  </v-btn>
                </v-list-tile-action>
                <v-list-tile-action>
                  <v-btn icon ripple @click="destroy(key, document)">
                    <v-icon color="grey lighten-1">fa-trash</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
          </v-flex>
        </v-layout>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import Document from '@/models/Document.js'
import DocumentRename from '@/components/DocumentRename.vue'
import get_file_size from '@/helpers/get_file_size.js'
import handle_validation_error from '@/helpers/handle_validation_error.js'
import handle_session_error from '@/helpers/handle_session_error.js'

export default {
  components: {
    DocumentRename,
  },

  props: ['event', 'editable'],

  data() {
    return {
      enable_rename_form: false,
      document_to_rename: new Document(),
    }
  },

  methods: {
    destroy(key, document) {
      // Delete document from event directly in the API if event is active or published.
      if (['active', 'published'].includes(this.event.status)) {
        this.$APICall(
          'delete',
          'DOCUMENTS',
          '/' + document.id,
          [],
          () => {},
          true,
          error => {
            handle_session_error(error, this.$store, this.$router, this.$prompt)
          }
        )
      }

      this.event.documents.splice(key, 1)
    },

    triggerDocumentInputClick() {
      this.$refs.documentInput.click()
    },

    handleDocumentInputChange() {
      for (
        let i = 0;
        i < Array.from(this.$refs.documentInput.files).length;
        i++
      ) {
        // If selected file is larger than 8MB, alert the user and don't upload the file.
        if (get_file_size(this.$refs.documentInput.files[i]) >= 1024 * 8) {
          this.$alert(this.$t('alerts.maxFileSizeLimit'))
          return
        }
      }

      Array.from(this.$refs.documentInput.files).forEach(file => {
        this.$APIUpload(
          file,
          data => {
            if (['active', 'published'].includes(this.event.status)) {
              // Add document directly to the event using the API.
              data.file.event_id = this.event.id

              this.$APICall(
                'post',
                'DOCUMENTS',
                '',
                data.file,
                data => {
                  this.event.documents.push(new Document(data.data))
                },
                true,
                error => {
                  handle_session_error(
                    error,
                    this.$store,
                    this.$router,
                    this.$prompt
                  )
                }
              )
            } else {
              this.event.documents.push(new Document(data.file))
            }
          },
          'UPLOAD_WITH_LOADER',
          null,
          error => {
            handle_validation_error(error, this.$alert)
            handle_session_error(error, this.$store, this.$router, this.$prompt)
          }
        )
      })
    },

    handleDocumentRename(document) {
      for (const index in this.event.documents) {
        // `this.document_to_rename` holds the document that was sent to be edited.
        // `document` is always modified (new) since it is being created from prop `documentProp` with `new Document`.
        if (Object.is(this.event.documents[index], this.document_to_rename)) {
          if (['active', 'published'].includes(this.event.status)) {
            this.$APICall(
              'put',
              'DOCUMENTS',
              '/' + document.id,
              document,
              () => {},
              true,
              error => {
                handle_session_error(
                  error,
                  this.$store,
                  this.$router,
                  this.$prompt
                )
              }
            )
          }

          this.event.documents.splice(index, 1, document)
        }
      }
    },

    openDocumentRenameDialog(document) {
      this.document_to_rename = document
      this.enable_rename_form = true
    },

    setPublic(document) {
      document.setPublic()

      if (['active', 'published'].includes(this.event.status)) {
        this.$APICall(
          'get',
          'DOCUMENTS',
          '/' + document.id + '/public',
          [],
          () => {},
          true,
          error => {
            handle_session_error(error, this.$store, this.$router, this.$prompt)
          }
        )
      }
    },

    setPrivate(document) {
      document.setPrivate()

      if (['active', 'published'].includes(this.event.status)) {
        this.$APICall(
          'get',
          'DOCUMENTS',
          '/' + document.id + '/private',
          [],
          () => {},
          true,
          error => {
            handle_session_error(error, this.$store, this.$router, this.$prompt)
          }
        )
      }
    },
  },
}
</script>

<style scoped></style>
